import { useCallback, useEffect, useState } from 'react';
import { getUserActionActions, getUserActionCategories } from '../api';

export interface UseCategoriesResult {
  categories: string[];
  actions: string[];
  loadingCategories: boolean;
  loadingActions: boolean;
}

export function useUserActionCategories(selectedCategory: string | null): UseCategoriesResult {
  const [categories, setCategories] = useState<string[]>([]);
  const [actions, setActions] = useState<string[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingActions, setLoadingActions] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoadingCategories(true);
    getUserActionCategories()
      .then((d) => {
        if (!cancelled) setCategories(d);
      })
      .catch(() => {
        if (!cancelled) setCategories([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingCategories(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const loadActions = useCallback((category: string | null) => {
    let cancelled = false;
    setLoadingActions(true);
    getUserActionActions(category)
      .then((d) => {
        if (!cancelled) setActions(d);
      })
      .catch(() => {
        if (!cancelled) setActions([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingActions(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const cleanup = loadActions(selectedCategory);
    return cleanup;
  }, [selectedCategory, loadActions]);

  return { categories, actions, loadingCategories, loadingActions };
}
